import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useOnboardingContext } from "../../Context";
import { CreateAccountContext } from "./types";

export function useRedirectToAccountType() {
  const history = useHistory();

  const [context] = useOnboardingContext<CreateAccountContext>();

  useEffect(() => {
    const path = history.location.pathname.substring(
      0,
      history.location.pathname.lastIndexOf("/create-account")
    );

    if (!context.accountType) {
      history.replace(path + "/account-type");
    }
  }, [context.accountType, history]);
}
